// extracted by mini-css-extract-plugin
export default {"title":"ckKcm1yNcUO9hMj3HOAL","subtitle":"Bh8xS9KxHhMoFCOtOM9s","button":"qvhK3XHiGIkf8pKaYNYz"};